{
  "warehouseMasterTableConfig": {
    "columns": [
      {
        "fieldName": "name",
        "displayName": "Warehouse Name",
        "dataType": "STRING"
    
      },
      {
        "fieldName": "totalVolume",
        "displayName": "Total Volume",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "140px"
        },
        "styleConfig": {
          "type": "badge",
          "conditions": [
            {
              "expression": "eq(value, undefined)",
              "styleProperties": {
                "display": "none"
              }
            }
          ],
          "styleProperties": {
            "width": "100px",
            "display": "flex",
            "align-items": "center",
            "border-radius": "6px",
            "border": "1px solid #D0D5DD",
            "background": "var(--Gray-100, #F2F4F7)",
            "box-shadow": "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
            "color": "var(--Gray-700, #344054)",
            "text-align": "center",
            "font-family": "Inter",
            "font-size": "12px",
            "font-style": "normal",
            "font-weight": "500",
            "line-height": "18px"
          }
        }
      },
      {
        "fieldName": "description",
        "displayName": "Description",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "200px"
        }

      },
      {
        "fieldName": "active",
        "displayName": "Status",
        "dataType": "BOOLEAN",
        "valueMap": {
          "true": "Active",
          "false": "Inactive"
        },
        "thStyleConfig": {
          "width": "60px"
        },
        "styleConfig": {
          "type": "status"
        }
      },
      {
        "fieldName": "createdDate",
        "displayName": "Created Date",
        "dataType": "DATETIME"
      },
      {
        "fieldName": "createdBy",
        "displayName": "Created By",
        "dataType": "STRING",
        "hasLookup": true,
        "styleConfig": {
          "type": "user-avatar"
        }
      },
      {
        "fieldName": "modifiedDate",
        "displayName": "Modified Date",
        "dataType": "DATETIME",
        "sortable": true
      },
      {
        "fieldName": "modifiedBy",
        "displayName": "Modified By",
        "dataType": "STRING",
        "styleConfig": {
          "type": "user-avatar"
        }
      }
    ],    
    "actions":[
      {
        "fieldName": "",
        "displayName": "",
        "dataType": "STRING",
        
        "thStyleConfig": {
          "width": "50px"
        },
        "styleConfig": {
          "type": "action",
          "icon": "assets/icons/warehouse.svg",
          "iconStyleProperties": {
            "background": "var(#344054)",
            "height": "21px",
            "width": "32px"

          },
          "styleProperties": {
            "border-radius": "8px",
            "background": "none",
            "border": "none"
          },
            "buttonConfig": {
            "label": "",
            "writeOperation": false,
            "actionName":"view-warehouse"
          
          }
        }
      }
    ]
  },
  "filterConfig": {
    "filterFields": [
      {
        "name": "NAME_CONTAINS",
        "displayLabel": "Name",
        "dataType": "STRING",
        "operatorToFilterMap": {
          "CONTAINS": "NAME_CONTAINS"
        }
      },
  
      {
        "name": "ACTIVE_EQUALS",
        "displayLabel": "Active",
        "dataType": "BOOLEAN",
        "operatorToFilterMap": {
          "EQ": "ACTIVE_EQUALS"
        }
      }
    
    ],
    "useNewContract": true
  },
  
  "searchBarConfig": {
    "placeHolder": "Search Warehouse by name",
    "filters": [
      {
        "name": "NAME_CONTAINS",
        "alias": "warehouse_name"
      }
    ]
  }
}
